// extracted by mini-css-extract-plugin
export default {"paginationLinks":"paginationLinks_VngWb"};